import React, {PureComponent} from "react";
// import { resolvePath } from "../projects/utils";
// import Axios from "axios";
import UIAudioVisualiser from "./UIAudioVisualiser";

export function resolvePath(path: any) {
  return new Promise((resolve, reject) => {
    try {
      //@ts-ignore
      window["resolveLocalFileSystemURL"](
        path,
        (entry: any) => {
          resolve(entry);
        },
        (error: any) => {
          reject(error);
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}
export default class UIRecorder extends PureComponent {
  state = {
    recorder: null,
    recording: false,
    currentTime: 0,
    mediaRecorder: null,
    amp: 0,
    stream: null,
  };
  init = async () => {
    var constraints = { audio: true };
    let stream = await navigator.mediaDevices.getUserMedia(constraints);
    this.setState({ stream });
    console.log("init stream ");
  };
  componentWillMount() {
    this.init();
  }
  //@ts-ignore
  readFile = (fileEntry: FileEntry) => {
    //@ts-ignore
    const { onStop } = this.props;
    fileEntry.file(
      (file: File) => {
        var reader = new FileReader();
        reader.onloadend = function (event) {
          //@ts-ignore
          let result: ArrayBuffer = event.target.result;
          console.log("Successful file read target: ", result);
          let blob = new Blob([new Uint8Array(result)], {
            type: file.type,
          });
          console.log("Blob:", blob);
          onStop({
            nativeFileURL: fileEntry.fullPath,
            blob: blob,
            blobURL: URL.createObjectURL(blob),
            arrayBuffer: this.result,
          });
        };
        reader.readAsArrayBuffer(file);
      },
      (e: any) => {
        console.error("[FileEntry]", e);
      }
    );
  };

  record = async () => {
    //@ts-ignore
    const { onStop } = this.props;
    let fileName = "audio-record.webm";
    let path = "cdvfile://localhost/temporary/" + fileName;
    //@ts-ignore
    if (window.cordova && window.Media) {
      //@ts-ignore
      let mediaRecorder = new window.Media(
        path,
        async () => {
          console.log("recordAudio():Audio Success:", path);
          var fileEntry = await resolvePath(path);
          this.readFile(fileEntry);
        },
        (err: any) => {
          console.log("recordAudio():Audio Error: " + err.code);
        }
      );
      mediaRecorder.startRecord();
      this.setState({ mediaRecorder });
    } else if (navigator.mediaDevices) {
      console.log("getUserMedia supported.");
      let type = "audio/webm";
      var options = { mimeType: type };
      var constraints = { audio: true };
      var chunks: any = [];
      //@ts-ignore
      this.state.stream.getTracks().forEach((track) => {
        track.stop();
      });
      let stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.setState({ stream });
      //@ts-ignore
      var mediaRecorder = new window.MediaRecorder(stream);
      mediaRecorder.onstop = function (e: any) {
        // console.log("data available after MediaRecorder.stop() called.");
        var audio = document.createElement("audio");
        audio.setAttribute("controls", "");
        audio.controls = true;

        console.log("type", type);
        var blob = new Blob(chunks, { type: type });
        chunks = [];
        var audioURL = URL.createObjectURL(blob);
        console.log("recorder stopped");

        // let audioE = document.getElementById("audioE");
        // //@ts-ignore
        // audioE.controls = true;
        // //@ts-ignore
        // audioE.src = audioURL;

        // var a = document.createElement("a");
        // a.href = audioURL;
        // a.download = "filename";
        // a.click();

        onStop({ blob, audioURL });
      };
      mediaRecorder.ondataavailable = function (e: any) {
        console.log("timeslice:", e.timeslice);
        chunks.push(e.data);
      };
      // mediaRecorder.ondataavailable = function(e) {
      //   chunks.push(e.data);
      // }
      mediaRecorder.start();
      this.setState({ mediaRecorder });
    }
  };
  startRecord = () => {
    console.debug("[start-recording]");
    this.setState({ recording: true });
    this.record();
  };
  stopRecord = () => {
    console.debug("[stop-recording]");
    this.setState({ recording: false });
    try {
      //@ts-ignore
      if (typeof this.state.mediaRecorder?.stop === "function") {
        //@ts-ignore
        this.state.mediaRecorder.stop();
        //@ts-ignore
        this.state.stream
          .getTracks() // get all tracks from the MediaStream
          .forEach((track: any) => track.stop()); // stop each of them
      }
      //@ts-ignore
      if (typeof this.state.mediaRecorder?.stopRecord === "function") {
        //@ts-ignore
        this.state.mediaRecorder.stopRecord();
        //@ts-ignore
        this.state.stream
          .getTracks() // get all tracks from the MediaStream
          .forEach((track: any) => track.stop()); // stop each of them
      }
    } catch (e) {}
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <UIAudioVisualiser
          //@ts-ignore
          amp={this.state.amp}
          playing={this.state.recording}
        />
      </div>
    );
  }
}
